import React, { Component } from 'react';
import { Link } from 'gatsby';
import {
  Image,
  Wrapper,
  HtmlContent,
  Stroke,
} from '..';
import './CallToActionBlock.scss';

class CallToActionBlock extends Component {
  render() {
    const { input } = this.props;
    const { primary } = input;
    const {
      image,
      title,
      textBody,
      buttonLabel,
      link,
    } = primary;
    return (
      <section className="call-to-action-block">
        <Wrapper>
          <div className="container">
            <h2 className="title mobile-title">{title.text}</h2>
            <div className="image-col col">
              <Image image={image} className="cover" />
            </div>
            <div className="text-col col">
              <div className="text-container">
                <h2 className="title desktop-title">{title.text}</h2>
                <div className="text-body">
                  <HtmlContent content={textBody.html} />
                </div>
                <Link
                  to={`/${link.slug}/`}
                  className="read-more-button styled-arrow-button"
                  aria-label={`Navigate to ${buttonLabel.text} page`}
                >
                  <div className="button-text">
                    <span>{buttonLabel.text}</span>
                    <Stroke seedStr={buttonLabel.text} hasViewBox />
                  </div>
                  <svg className="arrow" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </Wrapper>
      </section>
    );
  }
}

export default CallToActionBlock;
